export default "__VITE_ASSET__549610b5__"